import { useFeatureFlag } from 'contexts/FeatureFlagProvider';
import React, { Fragment } from 'react';
import { Fallback } from './components/Fallback';
import { Spinner } from '@welbe/web-design-system';
import { Wrapper } from './FeatureFlag.styles';

export type FeatureFlagProps = {
	feature: string;
	children?: any;
	newComponent?: React.ReactNode;
	oldComponent?: React.ReactNode;
	newOperation?: any;
	oldOperation?: any;
	fallback?: boolean;
};

const NullComponent = () => {
	return (
		<Wrapper>
			<Spinner size="50px" />
		</Wrapper>
	);
};

export const FeatureFlagOperator = ({
	feature,
	newOperation,
	oldOperation,
}: FeatureFlagProps): any => {
	const { features } = useFeatureFlag();

	if (features === null) return <NullComponent />;

	return features[feature]?.enabled ? newOperation : oldOperation;
};

export const FeatureFlag = ({
	feature,
	children: ChildrenComponent,
	newComponent,
	oldComponent,
	fallback,
}: FeatureFlagProps): JSX.Element => {
	const { features } = useFeatureFlag();

	if (features === null) return <NullComponent />;

	if (newComponent && oldComponent) {
		return (
			<Fragment>
				{features[feature]?.enabled ? newComponent : oldComponent}
			</Fragment>
		);
	}

	if (features[feature]?.enabled) {
		return <ChildrenComponent />;
	}

	return <Fragment>{fallback ? <Fallback /> : null}</Fragment>;
};
